import React from "react";
import { Link } from "react-router-dom";
import "./Blogsection.css";

export default function BlogBoxHome({ blogdata }) {
  return (
    <>
      <div className="col col-md-4 col-xs-6 ">
        <div className="grid bg_light">
          <div className="entry-media">
            <img
              src={blogdata.sort_img}
              alt={blogdata.image_alt}
              title={blogdata.image_title}
              className="img img-responsive"
            />
          </div>
          <div className="blogcontentBox">
            <div className="entry-meta">
              <ul>
                <li>
                  <a href="/">
                    <i className="fa fa-clock-o" aria-hidden="true"></i>
                    {blogdata.date}
                  </a>
                </li>
                <li>
                  <a href="/">
                    <i className="fa fa-user" aria-hidden="true"></i>
                    {blogdata.author}
                  </a>
                </li>
              </ul>
            </div>
            <div className="entry-title">
              <h3>
                <Link to={`/blog/${blogdata.slug}`}>{blogdata.title}</Link>
              </h3>
            </div>

            <div className="entry-details">
              <Link
                to={`/blog/${blogdata.slug}`}
                className="read-more"
                rel="noreferrer"
                aria-label="All Blog Details"
              >
                Read More{" "}
                <i className="fa fa-angle-double-right" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
